import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/devices/_list/settings/')({
  beforeLoad: () => {
    throw redirect({
      to: '/devices/settings/catalog'
    });
  }
});